/**
 * Shared constants + helpers for the Reconcile page split.
 *
 * TAG_FILTERS drives the pill row. MONTHS / YEARS feed the period
 * dropdowns. todayIso() is reused everywhere a tag is computed.
 */
export const TAG_FILTERS = [
  { value: 'all', label: 'All' },
  { value: 'reconciled', label: 'Reconciled' },
  { value: 'pending', label: 'Pending' },
  { value: 'scheduled', label: 'Scheduled' },
];

export const MONTHS = [
  { value: 1, label: 'January' }, { value: 2, label: 'February' }, { value: 3, label: 'March' },
  { value: 4, label: 'April' }, { value: 5, label: 'May' }, { value: 6, label: 'June' },
  { value: 7, label: 'July' }, { value: 8, label: 'August' }, { value: 9, label: 'September' },
  { value: 10, label: 'October' }, { value: 11, label: 'November' }, { value: 12, label: 'December' },
];

export const YEARS = (() => {
  const now = new Date().getFullYear();
  return Array.from({ length: 11 }, (_, i) => now - 5 + i);
})();

export const todayIso = () => new Date().toISOString().split('T')[0];
